import React from 'react';
import { Box } from '@mui/material';
import styles from './HeaderAccount.module.css';
import { Skeleton } from '@mui/lab';

export const HeaderAccountLoading = () => {
  return (
    <Box className={styles.account} py={3} px={2}>
      <Skeleton variant="circle" width={48} height={48} />
      <div className={styles.accountContent}>
        <Skeleton height={16} width="80%" className={styles.skeletonName} />
        <Skeleton height={16} width="60%" />
      </div>
    </Box>
  );
};
